/**
 * @name EXPONENT_NEGATIVE
 * @constant
 * @string
 * @description Used to identify a number expressed in negative exponential notation
 */
export const EXPONENT_NEGATIVE = 'e-';

/**
 * @name EXPONENT_POSITIVE
 * @constant
 * @string
 * @description Used to identify a number expressed in positive exponential notation
 */
export const EXPONENT_POSITIVE = 'e+';

/**
 * @name MAX_DECIMAL_PLACE
 * @constant
 * @string
 * @description Determines the maximum decimal string length for number, including the decimal.
 * 
 * **Example**: Consider the string, `.23`. The length is `3`, where `.` is the first character and the last character is the third
 */
export const MAX_DECIMAL_PLACE = 4;

/**
 * @name MAGNITUDES
 * @constant
 * @string
 * @description List of magnitude ranges and their corresponding character representations
 */
export const MAGNITUDES = [
    // {
    //     name: 'atto', 
    //     max: Math.pow( 10, -15 ),
    //     min: Math.pow( 10, -18 ),
    //     symbol: 'a'
    // },
    {
        divisor: Math.pow( 10, -15 ),
        name: 'femto', 
        max: Math.pow( 10, -12 ),
        min: -Infinity,
        symbol: 'f'
    },
    {
        name: 'pico', 
        max: Math.pow( 10, -9 ),
        min: Math.pow( 10, -12 ),
        symbol: 'p'
    },
    {
        name: 'nano', 
        max: Math.pow( 10, -6 ),
        min: Math.pow( 10, -9 ),
        symbol: 'n'
    },
    {
        name: 'micro', 
        max: Math.pow( 10, -3 ),
        min: Math.pow( 10, -6 ),
        symbol: 'µ'
    },
    {
        name: 'micro', 
        max: Math.pow( 10, -3 ),
        min: Math.pow( 10, -6 ),
        symbol: 'u'
    },
    {
        name: 'milli', 
        //max: Math.pow( 10, 0 ),
        max: .9,
        min: Math.pow( 10, -3 ),
        symbol: 'm'
    },
    {
        name: 'giga', 
        max: Infinity,
        min: Math.pow( 10, 9 ),
        symbol: 'G'
    },
    {
        name: 'mega', 
        max: Math.pow( 10, 9 ),
        min: Math.pow( 10, 6 ),
        symbol: 'M'
    },
    {
        name: 'kilo', 
        max: Math.pow( 10, 6 ),
        min: Math.pow( 10, 3 ),
        symbol: 'k'
    },
    // {
    //     name: 'centi', 
    //     max: Math.pow( 10, -1 ),
    //     min: Math.pow( 10, -2 ),
    //     symbol: 'c'
    // },
    // {
    //     name: 'deci', 
    //     max: Math.pow( 10, 0 ),
    //     min: Math.pow( 10, -1 ),
    //     symbol: 'd'
    // },
    
   
    
    // {
    //     name: 'tetra', 
    //     max: Math.pow( 10, 15 ),
    //     min: Math.pow( 10, 12 ),
    //     symbol: 'T'
    // },
    // {
    //     name: 'penta', 
    //     max: Math.pow( 10, 18 ),
    //     min: Math.pow( 10, 15 ),
    //     symbol: 'P'
    // },
    // {
    //     name: 'exa', 
    //     max: Math.pow( 10, 21 ),
    //     min: Math.pow( 10, 18 ),
    //     symbol: 'E'
    // },
    // {
    //     name: 'zetta', 
    //     max: Math.pow( 10, 24 ),
    //     min: Math.pow( 10, 21 ),
    //     symbol: 'Z'
    // },
    // {
    //     name: 'yotta', 
    //     max: Math.pow( 10, 27 ),
    //     min: Math.pow( 10, 24 ),
    //     symbol: 'Y'
    // },
    // {
    //     name: 'quint', 
    //     max: Math.pow( 10, 30 ),
    //     min: Math.pow( 10, 27 ),
    //     symbol: 'Q'
    // }
];